<template>
  	<div class="animated fadeIn">
		<b-row>
			<b-col cols="12">
				<b-card header-tag="header" footer-tag="footer">
			        <div slot="header">
						<i class="fa fa-users"></i><strong> {{$trans[$route.meta.trans_key]['district']}}</strong> <small v-if="!loading1"> - {{item1.name}}</small>
			        </div>
			        <div>
						<b-row>
							<b-col lg="6">
								<b-row>
									<b-col md="12">
										<!-- <label for="choose-item">Escolher Concelho</label> -->
										<b-form-group :label="$trans[$route.meta.trans_key]['district']" label-for="sel-district">
											<b-form-select id="sel-district" v-model="id_item_selected">
												<option v-for="item in all_items" :key="item.id" :value="item.id">{{item.name}}</option>
											</b-form-select>
										</b-form-group>
									</b-col>
									<b-col md="12">
										<b-form-group :label="$trans[$route.meta.trans_key]['search_district']" :label-for="search1.id">
											<autosuggest v-bind:input="search1" v-bind:key_compare="'name'" v-bind:show="!loading1" v-bind:items="all_items" v-on:choose-item="choose_item_search1"></autosuggest>
										</b-form-group>
									</b-col>
								</b-row>
							</b-col>
						</b-row>
					</div>
				</b-card>
			</b-col>
		</b-row>
		<b-row>
			<b-col cols="12">
				<b-card header-tag="header" footer-tag="footer">
			        <div slot="header">
						<i class="fa fa-users"></i><strong> {{$trans['general']['censuses']}} 2011</strong><small v-if="!loading1"> - {{item1.name}}</small>
			        </div>
			       <div>
						<b-row>
							<b-col md="6">
								<b-form-group label="hidden-inp" class="invisible d-lg-block d-none">
									<b-form-select>
										<option></option>
									</b-form-select>
								</b-form-group>
								<b-tabs pills class="text-capitalize">
									<b-tab :title="$trans[$route.meta.trans_key]['resident_population']">
										<b-col md="12" :class="(!loading3) ? 'has_data' : ''" class="card-loader-container p-0">
											<loader v-if="loading3"></loader>
											<b-list-group v-else class="mobile-list">
												<b-list-group-item class="cursor-pointer" v-on:click="open_sec_item_infowindow(item, maps_data1.map_data.map_ele)" v-for="(item, idx) in sec_items1" :key="idx" v-html="item.name+ ': ' +item.population">
												</b-list-group-item>
											</b-list-group>
										</b-col>
									</b-tab>
									<b-tab :title="$trans[$route.meta.trans_key]['population_density']" v-on:click="tab1_2_idx = 1">
										<b-col md="12" :class="(!loading4) ? 'has_data' : ''" class="card-loader-container p-0">
											<loader v-if="loading4"></loader>
											<b-list-group v-else class="mobile-list">
												<b-list-group-item class="cursor-pointer" v-on:click="open_sec_item_infowindow(item, maps_data2.map_data.map_ele)" v-for="(item, idx) in sec_items2" :key="idx" v-html="item.name+ ': ' +item.population_density+ ' hab/km<sup>2</sup>'">
												</b-list-group-item>
											</b-list-group>
										</b-col>
									</b-tab>
								</b-tabs>
							</b-col>
							<b-col md="6">
								<div class="mt-lg-0 mt-4">
									<b-form-group :label="$trans[$route.meta.trans_key]['map_style']" label-for="sel-map-style">
										<b-form-select id="sel-map-style" v-model="map.style" text="Estilo do mapa" right>
											<option v-for="(item, idx) in map.styles" :key="idx" :value="item">{{item.name}}</option>
										</b-form-select>
									</b-form-group>
								</div>
								<b-tabs pills class="text-capitalize" v-model="tab1_2_idx">
									<b-tab :title="$trans[$route.meta.trans_key]['resident_population']">
										<div class="loader-wrapper text-transform-none">
											<loader v-if="loading3"></loader>
											<l-map-wrapper v-else v-bind:data="maps_data1" v-bind:mapStyle="map.style" v-on:setStyles="setMapStyles" :ref="maps_data1.map_data.map_ele" v-bind:mapType="'geojson'" class="my-map-leaflet"></l-map-wrapper>
										</div>
									</b-tab>
									<b-tab :title="$trans[$route.meta.trans_key]['population_density']">
										<div class="loader-wrapper text-transform-none">
											<loader v-if="loading4"></loader>
											<l-map-wrapper v-else-if="load_map2" v-bind:data="maps_data2" v-bind:mapStyle="map.style" v-on:setStyles="setMapStyles" :ref="maps_data2.map_data.map_ele" v-bind:mapType="'geojson'" class="my-map-leaflet"></l-map-wrapper>
										</div>
									</b-tab>
								</b-tabs>
								<div class="pop-legend mt-1">
									<div v-for="(item, idx) in legends[tab1_2_idx]" :key="idx" class="ml-2 d-inline-block"><div class="d-inline-block square align-middle" :style="'background-color:' +item"></div><span class="align-middle"> {{idx}}+</span></div>
								</div>
							</b-col>
						</b-row>
			        </div>
			    </b-card>
			</b-col>
		</b-row>
		<b-row>
			<b-col cols="12">
				<b-card header-tag="header" footer-tag="footer">
			        <div slot="header">
						<i class="fa fa-users"></i><strong> {{$trans['general']['censuses']}} 2011</strong> <small v-if="!loading1"> - {{item1.name}}</small>
			        </div>
			        <div>
						<b-row>
							<b-col md="12">
								<b-tabs pills class="text-capitalize">
									<b-tab v-for="(chart_v, chart_idx) in last_censos_charts_visual_types" :key="chart_idx" :title="(!loading1) ? last_censos_charts[chart_idx].tab_label : ''" v-on:click="activate_chart_last_censos(chart_idx)">
										<div :class="(!loading1) ? 'has_data' : ''" class="card-loader-container table-chart-wrapper">
											<loader v-if="loading1"></loader>  
											<div v-if="last_censos_charts.length > 0" class="chart-container">
												<b-col sm="4" offset-sm="8">
													<b-form-select v-model="last_censos_charts_visual_types[chart_idx]" :id="'choose-display_' +chart_idx">
														<option v-for="c_type in charts_visual_types_available" :value="c_type" :key="c_type">{{c_type}}</option>
													</b-form-select>
												</b-col>
												<div v-if="last_censos_chart_idx_active == chart_idx">
									    			<div v-if="chart_v === $trans[$route.meta.trans_key]['graphic']" class="censos_chart">

														<bar-chart v-if="last_censos_charts[chart_idx].type == 'bar'" v-bind:chartData="last_censos_charts[chart_idx]"></bar-chart>

														<line-chart v-else-if="last_censos_charts[chart_idx].type == 'line'" v-bind:chartData="last_censos_charts[chart_idx]"></line-chart>

													</div>
													<div v-else-if="chart_v === $trans[$route.meta.trans_key]['table']" class="censos_table">
														<datatable v-bind:data_table="last_censos_tables[chart_idx]"></datatable>
													</div>
												</div>
											</div>
										</div>
									</b-tab>
								</b-tabs>
							</b-col>
						</b-row>
			        </div>
			    </b-card>
			</b-col>
		</b-row>
		<b-row>
			<b-col cols="12">
				<b-card header-tag="header" footer-tag="footer">
			        <div slot="header">
						<i class="fa fa-users"></i><strong> {{$trans[$route.meta.trans_key]['yearly_evolution']}}</strong> <small v-if="!loading1"> - {{item1.name}}</small>
			        </div>
			        <div>
						<b-row>
							<b-col md="12">
								<b-tabs pills class="text-capitalize">
									<b-tab v-for="(chart_v, chart_idx) in charts_visual_types_old" :key="chart_idx" :title="(!loading2) ? censos_charts_old[chart_idx].tab_label : ''" v-on:click="activate_chart_old(chart_idx)">
										<div :class="(!loading2) ? 'has_data' : ''" class="card-loader-container table-chart-wrapper text-transform-none">
											<loader v-if="loading2"></loader>  
											<div v-if="censos_charts_old.length > 0" class="chart-container">
												<b-col md="8" v-if="typeof censos_charts_old[chart_idx].disclaimer !== 'undefined'" class="disclaimer-container margin-b-15">
													<p class="no-margin text-center font-11">{{censos_charts_old[chart_idx].disclaimer}}</p>
													<span class="icon-disclaimer" v-on:click="disclaimer_active = censos_charts_old[chart_idx].disclaimer"><span class="fa fa-info-circle"></span></span>
												</b-col>
												<b-col sm="4" offset-sm="8">
													<b-form-select v-model="charts_visual_types_old[chart_idx]" :id="'choose-display_' +chart_idx">
														<option v-for="c_type in charts_visual_types_available" :value="c_type" :key="c_type">{{c_type}}</option>
													</b-form-select>
												</b-col>
												<div v-if="chart_old_idx_active == chart_idx">
									    			<div v-if="chart_v === $trans[$route.meta.trans_key]['graphic']" class="censos_chart">

														<bar-chart v-if="censos_charts_old[chart_idx].type == 'bar'" v-bind:chartData="censos_charts_old[chart_idx]"></bar-chart>

														<line-chart v-else-if="censos_charts_old[chart_idx].type == 'line'" v-bind:chartData="censos_charts_old[chart_idx]"></line-chart>

													</div>
													<div v-else-if="chart_v === $trans[$route.meta.trans_key]['table']" class="censos_table">
														<datatable v-bind:data_table="censos_tables_old[chart_idx]"></datatable>
													</div>
												</div>
											</div>
										</div>
									</b-tab>
								</b-tabs>
							</b-col>
						</b-row>
			        </div>
			    </b-card>
			</b-col>
		</b-row>
		<modal v-if="disclaimer_active != null" v-on:close="disclaimer_active = null">
			<p slot="body">{{disclaimer_active}}</p>
		</modal>
	</div>
</template>

<script>
import LMapWrapper from '@/views/sub_components/LMapWrapper';

export default {
	name: 'Demo_Districts',
	components: {
		LMapWrapper
	},
	data() {
		return {
			disclaimer_active: null,
			all_items: [],
			id_item_selected: this.$route.params.id,
			tab1_2_idx: 0,
			item_details: {},
			sec_items: [],
			legends: [],
			maps_data1: null,
			load_map2: false,
			search1: {
				id: 'search-district',
				value: '',
				has_error: false,
				placeholder: this.$trans[this.$route.meta.trans_key]['district'],
				error: this.$trans[this.$route.meta.trans_key]['district']+ ' não encontrado'
			},
			loading1: true,
			loading2: true,
			loading3: true,
			loading4: true,
			last_censos_charts: [],
			last_censos_tables: [],
			last_censos_charts_visual_types: [this.$trans[this.$route.meta.trans_key]['graphic'], this.$trans[this.$route.meta.trans_key]['graphic'], this.$trans[this.$route.meta.trans_key]['graphic'],this.$trans[this.$route.meta.trans_key]['graphic'], this.$trans[this.$route.meta.trans_key]['graphic']],
			censos_charts_old: [],
			censos_tables_old: [],
			last_censos_chart_idx_active: 0,
			chart_old_idx_active: 0,
			charts_visual_types_old: [this.$trans[this.$route.meta.trans_key]['graphic'], this.$trans[this.$route.meta.trans_key]['graphic'], this.$trans[this.$route.meta.trans_key]['graphic']],
			charts_visual_types_available: [this.$trans[this.$route.meta.trans_key]['table'], this.$trans[this.$route.meta.trans_key]['graphic']],
			map: {style: null, styles: []}
		}
	},
	methods: {
		activate_chart_old: function(idx) {
			this.chart_old_idx_active = idx;
		},
		activate_chart_last_censos: function(idx) {
			this.last_censos_chart_idx_active = idx;
		},
		get_map_data1: function() {
			const that = this;
			that.get_req('districts/map_pop/' +that.id_item_selected,
				function() { // before
					that.loading3 = true;
	            },
				function(response) { // success
					that.maps_data1 = response.body.data.map1;
					that.legends[0] = response.body.data.legend; // garant order giving index that will be used in the right order
					that.sec_items1 = response.body.data.sec_items;
      				that.loading3 = false;
					// appending county geo at the first place, so we can see the stroke of the county behind
					/*if(that.maps_data1 !== null)
						that.maps_data2.map_data.geo_data.unshift(that.maps_data1.map_data.geo_data);*/
				},
				function(response) { // fail
					that.abort_404();
				},
				function(response) {
					
				}
			);
		},
		get_map_data2: function() {
			const that = this;
			that.get_req('districts/map_pop_density/' +that.id_item_selected,
				function() { // before
					that.loading4 = true;
	            },
				function(response) { // success
					that.maps_data2 = response.body.data.map2;
					that.legends[1] = response.body.data.legend; // garant order giving index that will be used in the right order
					that.sec_items2 = response.body.data.sec_items;
      				that.loading4 = false;
					// appending county geo at the first place, so we can see the stroke of the county behind
					/*if(that.maps_data1 !== null)
						that.maps_data2.map_data.geo_data.unshift(that.maps_data1.map_data.geo_data);*/
				},
				function(response) { // fail
					that.abort_404();
				},
				function(response) {
					
				}
			);
		},
		get_censos_data: function(censos_type) {
			const that = this;
			that.get_req('districts/' +censos_type+ '_censos/' +that.id_item_selected,
		        function() { // before
					if(censos_type == 'last') {
						that.loading1 = true;
					}
					else if(censos_type == 'old') {
						that.loading2 = true;
					}
		        },
		        function(response) { // success
					if(censos_type == 'last') {
						that.item_details = response.body.item_details;
						that.last_censos_charts = response.body.charts_data;
						that.last_censos_tables = response.body.tables_data;
						that.loading1 = false;
					}
					else if(censos_type == 'old') {
						that.censos_charts_old = response.body.charts_data;
						that.censos_tables_old = response.body.tables_data;
						that.loading2 = false;
					}
					if(that.search1.value != '') {
						that.search1.value = '';
						that.search1.has_error = false;
					}
		        },
		        function(response) { // fail
					that.abort_404();
		        },
		        function(response) {
		          
		        }
			);
		},
		do_search1: function() {
			if(this.search1.value.trim() !== '') {
				var item_selected_tmp = this.all_items.find((item, idx) => item.name == this.search1.value || item.name.toLowerCase() == this.search1.value.toLowerCase());
				if(typeof item_selected_tmp === 'undefined') {
					this.search1.has_error = true;
					return;
				}
				this.id_item_selected = item_selected_tmp.id;
				this.search1.has_error = false;
			}
		},
		set_map_styles: function(styles) {
			if(this.map_style_opt_selected == null) {
				this.map_style_opt_selected = styles[Math.floor(Math.random()*styles.length)];
			}
			this.map_styles_opts = styles;
		},
		open_sec_item_infowindow: function(item, ref) {
			this.$refs[ref].trigger_popup(item.id, ref);
		},
		setMapStyles: function(styles) {
			this.map.styles = styles;
			if(this.map.style === null)
				this.map.style = styles[0];
		},
		init_comp: function() {
			if(this.globs['districts'] !== null) {
				this.all_items = this.globs['districts'];
				this.id_item_selected = this.get_starter_item(this.globs['districts'], this.id_item_selected).id;
				return;
			}
			const that = this;
			that.get_req('districts/all',
				function() { // before
					//that.loading = true;
	            },
				function(response) { // success
					that.all_items = response.body;
					that.globs['districts'] = that.all_items;
					that.id_item_selected = that.get_starter_item(that.all_items, that.id_item_selected).id;
				},
				function(response) { // fail
					that.abort();
					alert('ajax main.js error: '+ response.status);
				},
				function(response) {
					
				});
		},
	},
	watch: {
		id_item_selected: function(new_val, old_val) {
			if(typeof this.id_item_selected === 'undefined') {
				this.init_comp();
			}
			else {
				this.get_censos_data('last');
				this.get_censos_data('old');
				this.get_map_data1();
				this.get_map_data2();
			}
		},
		'$route.params.id': function(new_val, old_val) {
			if(typeof new_val === 'undefined') { //back button porpuses
				this.$router.go(-1);
			}
			else if(this.id_item_selected != new_val) {
				this.id_item_selected = new_val;
			}
		},
		item_details: function(new_val, old_val) {
			this.$router.push({name: 'Demographic_Districts', params: {lang: this.$lang, id: this.id_item_selected, slug: new_val.slug}});
			this.tab1_2_idx = 0;
			this.load_map2 = false;
		},
		tab1_2_idx: function(new_val, old_val) {
			if(new_val == 1 && !this.load_map2) {
				this.load_map2 = true;
			}
		},
	},
	computed: {
		item1: function() {
			if(!this.loading1) {
				this.item_details['population_density'] = ((this.item_details.population/this.item_details.area_km).toFixed(2));
			}
			return this.item_details;
		},
	},
	created: function() {
		this.init_comp();
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.pop-legend .square {
	width: 30px;
	height: 15px;
}
</style>